/** Primary browse/staff tabs. Switching these must not stack history. */
export function isTabRoot(pathname = '') {
  if (pathname === '/' || pathname === '/alerts' || pathname === '/profile') {
    return true;
  }
  if (pathname === '/admin' || pathname === '/admin/') return true;
  if (/^\/admin\/(content|analytics|users|alerts|sources|intake)\/?$/.test(pathname)) {
    return true;
  }
  return false;
}

/** React Router v6 stores an in-app index on history.state.idx. */
export function historyCanGoBack() {
  if (typeof window === 'undefined') return false;
  const idx = window.history.state?.idx;
  return typeof idx === 'number' && idx > 0;
}

export function pathFromLocation(location) {
  if (!location) return '/';
  return `${location.pathname}${location.search || ''}`;
}

/** After login, staff land on Dashboard unless they were mid-story or alerts. */
export function loginLandingPath(from, role) {
  const staffHome = '/admin';
  const readerHome = '/';
  const staff = role === 'admin' || role === 'maker' || role === 'checker';
  if (typeof from === 'string' && from.startsWith('/') && !from.startsWith('//')) {
    if (from === '/login' || from === '/signup') {
      return staff ? staffHome : readerHome;
    }
    if (staff && (from === '/' || from.startsWith('/?'))) return staffHome;
    return from;
  }
  return staff ? staffHome : readerHome;
}

export function backLabel(from) {
  if (!from) return 'Back';
  if (from === '/' || from.startsWith('/?')) return 'Feed';
  if (from.startsWith('/alerts')) return 'Alerts';
  if (from.startsWith('/admin/content')) return 'Content';
  if (from.startsWith('/admin/alerts')) return 'Compose';
  if (from.startsWith('/admin')) return 'Dashboard';
  if (from.startsWith('/profile')) return 'Profile';
  return 'Back';
}
